import {
  CircularProgress, InputAdornment, TextField,
} from '@mui/material';
import Icon from 'components/Icon';
import IconButton from 'components/IconButton';
import React from 'react';

export default function SearchLocation({
  loading, value, onChange, sx,
}) {
  return (
    <TextField
      onChange={(e) => onChange(e.target.value)}
      value={value}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            {loading ? (
              <CircularProgress size={20} />
            ) : (
              <Icon name="search-outlined" size={20} color="text.disabled" />
            )}
          </InputAdornment>
        ),
        endAdornment: (
          <InputAdornment position="end">
            <Icon name="close-filled" sx={{ cursor: 'pointer' }} onClick={() => onChange('')} />
          </InputAdornment>
        ),
      }}
      variant="outlined"
      placeholder="Search for an address"
      sx={{
        maxWidth: '100%',
        '& .MuiInputBase-root': {
          // backgroundColor: 'grey.200',
          pr: '12px !important',
        },
        width: {
          xs: '100%',
        },
        ...sx,
        // '& .MuiOutlinedInput-notchedOutline': {
        //   border: 'none',
        // },
        // '& input': {
        //   height: '1rem',
        // },
      }}
      // {...props}

    />
  );
}
